module.exports = __webpack_public_path__ + "img/couples_08_V.89cf0643.jpg";